import { render, staticRenderFns } from "./SwitchField.vue?vue&type=template&id=53f5cc44"
import script from "./SwitchField.vue?vue&type=script&lang=ts"
export * from "./SwitchField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports